var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting_balloon setting_balloon_category_add" },
    [
      _c("div", { staticClass: "setting_balloon_content" }, [
        _c("div", { staticClass: "setting_balloon_content_main" }, [
          _c("div", { staticClass: "setting_balloon_rows" }, [
            _c("div", { staticClass: "setting_balloon_rows_label" }, [
              _c("p", { staticClass: "setting_balloon_rows_label_name" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.labelProperties.labelItemName) +
                    "\n          "
                )
              ]),
              _c("p", { staticClass: "setting_label" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.labelProperties.labelRequired) +
                    "\n          "
                )
              ])
            ]),
            _c("div", { staticClass: "setting_balloon_rows_form" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.item.itemName,
                    expression: "item.itemName"
                  }
                ],
                staticClass: "setting_form_text",
                attrs: {
                  type: "text",
                  placeholder: _vm.labelProperties.placeholderItemName
                },
                domProps: { value: _vm.item.itemName },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.item, "itemName", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _c("div", { staticClass: "setting_balloon_rows" }, [
            _c("div", { staticClass: "setting_balloon_rows_label" }, [
              _c("p", { staticClass: "setting_balloon_rows_label_name" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.labelProperties.labelItemContent) +
                    "\n          "
                )
              ]),
              _c("p", { staticClass: "setting_label" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.labelProperties.labelRequired) +
                    "\n          "
                )
              ])
            ]),
            _c(
              "div",
              { staticClass: "setting_balloon_rows_form" },
              [
                _c(
                  "draggable",
                  {
                    attrs: {
                      list: _vm.item.resourceField,
                      draggable: ".item",
                      group: {
                        name: "item-company",
                        put: _vm.checkResourceLength() === 0
                      }
                    },
                    on: {
                      add: function($event) {
                        return _vm.addItemToResourceField()
                      }
                    }
                  },
                  [
                    _vm._l(_vm.item.resourceField, function(resource, index) {
                      return _c("div", { key: index, staticClass: "item" }, [
                        !resource.itemResourceDeleted
                          ? _c("div", { staticClass: "setting_form_wrapper" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: resource.display_name,
                                    expression: "resource.display_name"
                                  }
                                ],
                                staticClass: "setting_form_text",
                                class: {
                                  "resource-delete-setting":
                                    resource.isItemDeletedByMainSystem
                                },
                                attrs: {
                                  type: "text",
                                  placeholder:
                                    _vm.labelProperties.placeholderDropDragItem,
                                  readonly: ""
                                },
                                domProps: { value: resource.display_name },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      resource,
                                      "display_name",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _c(
                                "div",
                                {
                                  staticClass: "setting_form_wrapper_close",
                                  on: {
                                    click: function($event) {
                                      return _vm.deleteResource(index)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "12",
                                        height: "12",
                                        xmlns: "http://www.w3.org/2000/svg"
                                      }
                                    },
                                    [
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            fill: "none",
                                            "fill-rule": "evenodd"
                                          }
                                        },
                                        [
                                          _c("rect", {
                                            attrs: {
                                              fill: "#555",
                                              width: "12",
                                              height: "12",
                                              rx: "2"
                                            }
                                          }),
                                          _c("g", { attrs: { fill: "#FFF" } }, [
                                            _c("path", {
                                              attrs: {
                                                d:
                                                  "M2.853 3.893l.99-.99 5.304 5.304-.99.99z"
                                              }
                                            }),
                                            _c("path", {
                                              attrs: {
                                                d:
                                                  "M8.157 2.903l.99.99-5.304 5.304-.99-.99z"
                                              }
                                            })
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          : _vm._e()
                      ])
                    }),
                    _vm.checkResourceLength() === 0
                      ? _c(
                          "div",
                          {
                            staticClass: "setting_form_wrapper",
                            attrs: { slot: "footer" },
                            slot: "footer"
                          },
                          [
                            _c("input", {
                              staticClass: "setting_form_text",
                              attrs: {
                                type: "text",
                                placeholder:
                                  _vm.labelProperties.placeholderDropDragItem,
                                readonly: ""
                              }
                            })
                          ]
                        )
                      : _vm._e()
                  ],
                  2
                )
              ],
              1
            )
          ])
        ])
      ]),
      _c("div", { staticClass: "setting_balloon_footer" }, [
        _c(
          "button",
          {
            staticClass: "setting_btn_outline setting_btn_small",
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.$emit("close")
              }
            }
          },
          [
            _vm._v(
              "\n      " + _vm._s(_vm.labelProperties.buttonCancel) + "\n    "
            )
          ]
        ),
        _c(
          "button",
          {
            staticClass: "setting_btn_primary setting_btn_small",
            class: {
              setting_btn_disabled:
                !_vm.item.itemName || _vm.checkResourceLength() <= 0
            },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.$emit("submit")
              }
            }
          },
          [
            _vm._v(
              "\n      " + _vm._s(_vm.labelProperties.buttonReflect) + "\n    "
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }